import { Upload } from 'tus-js-client';
import config from '../config';

type InputFile = Blob & { [key: string]: any };

export interface OutputFile {
  name: string;
  path: string;
  type: string;
  size: number;
  url: string;
}

export default function tusUploader(
  file: InputFile,
  updateProgress?: (progress: number) => void
): Promise<any> {
  return new Promise((resolve, reject) => {
    const upload = new Upload(file, {
      endpoint: config.UPLOAD,
      removeFingerprintOnSuccess: true,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('feathers-jwt')}`
      },
      retryDelays: [0, 3000, 5000, 10000, 20000],
      metadata: {
        name: file.name,
        type: file.type
      },
      onError: function (error: any) {
        reject(error);
      },
      onProgress: function (bytesUploaded: number, bytesTotal: number) {
        const percentage = Number(
          ((bytesUploaded / bytesTotal) * 100).toFixed(2)
        );
        updateProgress?.(percentage);
      },
      onSuccess: function () {
        const { name, size, type } = file;
        const { url } = upload;
        const path = `/uploads${url?.split('/uploads')[1]}`;
        resolve({ name, path, size, type, url });
      }
    });
    upload.start();
  });
}
